var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircleSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "teenyicons:tick-circle-solid",
    clipPath: "url(#clip0_19310_26400)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 6.01088 0.790176 4.10322 2.1967 2.6967C3.60322 1.29018 5.51088 0.5 7.5 0.5C9.48912 0.5 11.3968 1.29018 12.8033 2.6967C14.2098 4.10322 15 6.01088 15 8C15 9.98912 14.2098 11.8968 12.8033 13.3033C11.3968 14.7098 9.48912 15.5 7.5 15.5C5.51088 15.5 3.60322 14.7098 2.1967 13.3033C0.790176 11.8968 0 9.98912 0 8H0ZM7.072 11.21L11.39 5.812L10.61 5.188L6.928 9.789L4.32 7.616L3.68 8.384L7.072 11.211V11.21Z",
    fill: "#3C5A99"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19310_26400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircleSolid);
export default __webpack_public_path__ + "static/media/tick-circle-solid.1e8147d4.svg";
export { ForwardRef as ReactComponent };